module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1 && _vm.$route.path.indexOf('_detail') === -1) ? _c('div', [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "操作说明",
      "show-icon": ""
    }
  }, [_c('div')])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "mini",
      "placeholder": "是否启用"
    },
    on: {
      "change": _vm.isValidSelectHandle
    },
    model: {
      value: (_vm.params.is_valid),
      callback: function($$v) {
        _vm.$set(_vm.params, "is_valid", $$v)
      },
      expression: "params.is_valid"
    }
  }, _vm._l((_vm.isValidList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "mini"
    },
    on: {
      "change": _vm.plantSelectHandle
    },
    model: {
      value: (_vm.params.is_third),
      callback: function($$v) {
        _vm.$set(_vm.params, "is_third", $$v)
      },
      expression: "params.is_third"
    }
  }, _vm._l((_vm.third_plant), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-cascader', {
    attrs: {
      "placeholder": "所属大区",
      "options": _vm.new_office_area,
      "props": {
        checkStrictly: true
      },
      "size": "mini",
      "clearable": ""
    },
    on: {
      "change": _vm.handleOfficeChange
    },
    model: {
      value: (_vm.selected_office_area_id),
      callback: function($$v) {
        _vm.selected_office_area_id = $$v
      },
      expression: "selected_office_area_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-col', [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.office_area_id),
      callback: function($$v) {
        _vm.office_area_id = $$v
      },
      expression: "office_area_id"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "mini",
      "placeholder": "选择店铺类型"
    },
    on: {
      "change": _vm.shopTypesSelectHandle
    },
    model: {
      value: (_vm.params.shop_type_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "shop_type_id", $$v)
      },
      expression: "params.shop_type_id"
    }
  }, [_vm._l((_vm.shop_type_list_default), function(shop) {
    return _c('el-option', {
      key: shop.shop_type_id,
      attrs: {
        "label": shop.shop_type_name,
        "value": shop.shop_type_id
      }
    })
  }), _vm._v(" "), _vm._l((_vm.shop_type_list), function(shop) {
    return _c('el-option', {
      key: shop.shop_type_id,
      attrs: {
        "label": shop.shop_type_name,
        "value": shop.shop_type_id
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "店铺id",
      "size": "mini"
    },
    model: {
      value: (_vm.params.distributor_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "distributor_id", $$v)
      },
      expression: "params.distributor_id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "店铺英克ID",
      "size": "mini"
    },
    model: {
      value: (_vm.params.number),
      callback: function($$v) {
        _vm.$set(_vm.params, "number", $$v)
      },
      expression: "params.number"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-input', {
    attrs: {
      "rows": 1,
      "placeholder": "店铺批量查询，多个英克ID之间使用回车符隔开",
      "type": "textarea",
      "clearable": "",
      "size": "mini"
    },
    model: {
      value: (_vm.params.numbers),
      callback: function($$v) {
        _vm.$set(_vm.params, "numbers", $$v)
      },
      expression: "params.numbers"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "店铺名称",
      "size": "mini"
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v)
      },
      expression: "params.name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "店铺地址",
      "size": "mini"
    },
    model: {
      value: (_vm.params.address),
      callback: function($$v) {
        _vm.$set(_vm.params, "address", $$v)
      },
      expression: "params.address"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "固定电话",
      "size": "mini"
    },
    model: {
      value: (_vm.params.telephone),
      callback: function($$v) {
        _vm.$set(_vm.params, "telephone", $$v)
      },
      expression: "params.telephone"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商家id",
      "size": "mini"
    },
    model: {
      value: (_vm.params.merchant_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "merchant_id", $$v)
      },
      expression: "params.merchant_id"
    }
  })], 1), _vm._v(" "), (_vm.system_mode === 'platform') ? _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-cascader', {
    attrs: {
      "size": "mini",
      "placeholder": "选择标签",
      "options": _vm.tag.list,
      "props": {
        value: 'tag_id',
        label: 'tag_name'
      },
      "clearable": ""
    },
    on: {
      "change": _vm.TagChangeAction
    },
    model: {
      value: (_vm.select_tags_value),
      callback: function($$v) {
        _vm.select_tags_value = $$v
      },
      expression: "select_tags_value"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "size": "mini",
      "placeholder": "联系人手机号"
    },
    model: {
      value: (_vm.params.mobile),
      callback: function($$v) {
        _vm.$set(_vm.params, "mobile", $$v)
      },
      expression: "params.mobile"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-button-group', [(!_vm.is_distributor) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-edit"
    },
    on: {
      "click": function($event) {
        return _vm.dialogOpen()
      }
    }
  }, [_vm._v("添加店铺")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-edit"
    },
    on: {
      "click": _vm.editCategoryAction
    }
  }, [_vm._v(" 店铺商品分类 ")]), _vm._v(" "), (!_vm.is_distributor) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-edit"
    },
    on: {
      "click": _vm.addDistributorTag
    }
  }, [_vm._v("打标签")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-edit"
    },
    on: {
      "click": _vm.exportDistributorInfo
    }
  }, [_vm._v("导出店铺基本信息")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-edit"
    },
    on: {
      "click": _vm.mulitClose
    }
  }, [_vm._v("批量关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-edit"
    },
    on: {
      "click": _vm.mulitOpen
    }
  }, [_vm._v("批量开启")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 140
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "label": "全选"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "店铺名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "distributor_id",
      "label": "店铺ID"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.distributor_id) + "\n        ")]
      }
    }], null, false, 1822958976)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number",
      "label": "店铺英克ID"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.number) + "\n        ")]
      }
    }], null, false, 155182142)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "contact",
      "label": "联系人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "telephone",
      "label": "电话"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "store_address",
      "label": "地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否启用"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.is_valid == 'true') ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("启用")]) : _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("禁用")])]
      }
    }], null, false, 1615110419)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "省医保"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.is_yibao == '1' && scope.row.yibao_code != '') ? _c('el-tag', {
          staticClass: "shengyibao_status",
          attrs: {
            "title": "点击查询店铺省医保状态",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.getDistributorNetStatus(scope.row.distributor_id)
            }
          }
        }, [_vm._v("已开通")]) : _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("未开通")])]
      }
    }], null, false, 3756752497)
  }), _vm._v(" "), (_vm.system_mode === 'platform') ? _c('el-table-column', {
    attrs: {
      "prop": "tagList",
      "label": "标签"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.tagList), function(taglist) {
          return _c('el-tag', {
            key: taglist.index,
            staticStyle: {
              "display": "inline-block",
              "margin-right": "3px"
            },
            style: ('color:' + taglist.font_color),
            attrs: {
              "color": taglist.tag_color,
              "size": "mini"
            }
          }, [_vm._v(_vm._s(taglist.tag_name))])
        })
      }
    }], null, false, 1851662175)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              path: _vm.matchHidePage('editor'),
              query: {
                distributor_id: scope.row.distributor_id
              }
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('router-link', {
          attrs: {
            "to": {
              path: _vm.matchInternalRoute('Storeshopitemanagement'),
              query: {
                distributor_id: scope.row.distributor_id
              }
            }
          }
        }, [_vm._v("商品")]), _vm._v(" "), _c('router-link', {
          attrs: {
            "to": {
              path: 'Shopcategorys',
              query: {
                distributor_id: scope.row.distributor_id
              }
            }
          }
        }, [_vm._v("分类")]), _vm._v(" "), _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_c('router-link', {
          attrs: {
            "to": {
              path: 'distributor_template',
              query: {
                template_name: 'yykweishop',
                distributor_name: scope.row.name,
                distributor_id: scope.row.distributor_id
              }
            }
          }
        }, [_vm._v("模板编辑")])], 1), _vm._v(" "), _c('el-button', {
          staticClass: "btn-gap",
          attrs: {
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.tagUpdate(scope.row)
            }
          }
        }, [_vm._v("标签")]), _vm._v(" "), _c('router-link', {
          attrs: {
            "to": {
              path: _vm.matchHidePage('editor'),
              query: {
                copy_dis_id: scope.row.distributor_id
              }
            }
          }
        }, [_vm._v("复制店铺")])]
      }
    }], null, false, 3904500194)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下载码",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.downDistributor(scope.row)
            }
          }
        }, [_vm._v("店铺码(微商城)")])]
      }
    }], null, false, 966431655)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "APP二维码"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.showQR(scope.row)
            }
          }
        }, [_vm._v("点击下载")])]
      }
    }], null, false, 3167814309)
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-top-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next, total, sizes",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50, 100, 200],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "下载店铺码",
      "visible": _vm.downDistributorVal,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.downDistributorVal = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.downDistributorCode(_vm.rowdata)
      }
    }
  }, [_vm._v("微商城小程序")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "width": "80%",
      "title": "编辑店铺首页",
      "fullscreen": "",
      "lock-scroll": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('shopDecoration', {
    attrs: {
      "id": _vm.current
    },
    on: {
      "saved": _vm.closeDialog
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.pcDialogVisible,
      "width": "80%",
      "title": "编辑PC店铺首页",
      "fullscreen": "",
      "lock-scroll": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.pcDialogVisible = $event
      }
    }
  }, [(_vm.pcDialogVisible) ? _c('pc-decoration', {
    attrs: {
      "id": _vm.current,
      "usage": "store"
    },
    on: {
      "saved": _vm.closeDialog
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "right-dialog",
    attrs: {
      "title": "为店铺打标签",
      "visible": _vm.tag.dialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.tag, "dialog", $event)
      }
    }
  }, [_c('div', {
    staticClass: "tag-users view-flex view-flex-middle"
  }), _vm._v(" "), _c('div', {
    staticClass: "selected-tags view-flex"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("已选中标签：")]), _vm._v(" "), _c('div', {
    staticClass: "view-flex-item"
  }, _vm._l((_vm.tag.currentTags), function(tag, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "closable": "",
        "size": "small",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.tagRemove(index)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])
  }), 1)]), _vm._v(" "), _c('div', _vm._l((_vm.tag.tags), function(tag, index) {
    return _c('el-tag', {
      key: index,
      staticClass: "tag-item",
      attrs: {
        "size": "medium",
        "color": "#ffffff",
        "disable-transitions": false
      },
      nativeOn: {
        "click": function($event) {
          return _vm.tagAdd(tag, index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(tag.tag_name) + "\n        ")])
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.tag.dialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitItemTag
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitleCategroy,
      "visible": _vm.editCategroyVisible,
      "before-close": _vm.handleCancel
    },
    on: {
      "update:visible": function($event) {
        _vm.editCategroyVisible = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "label-width": "120px"
      }
    }, [_c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkAll),
        expression: "checkAll"
      }],
      attrs: {
        "type": "checkbox",
        "id": "checkAll"
      },
      domProps: {
        "checked": Array.isArray(_vm.checkAll) ? _vm._i(_vm.checkAll, null) > -1 : (_vm.checkAll)
      },
      on: {
        "click": function($event) {
          return _vm.clickCheckAll()
        },
        "change": function($event) {
          var $$a = _vm.checkAll,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkAll = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkAll = $$c
          }
        }
      }
    }), _vm._v(" 全选/反选\n          ")]), _vm._v(" "), (_vm.categoryList_len > 0) ? _c('div', {}, _vm._l((_vm.categoryList), function(item, index) {
      return _c('div', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.isChecked),
          expression: "item.isChecked"
        }],
        staticClass: "weui-check",
        attrs: {
          "type": "checkbox",
          "name": "checkbox1",
          "data-id": item.category_id
        },
        domProps: {
          "checked": Array.isArray(item.isChecked) ? _vm._i(item.isChecked, null) > -1 : (item.isChecked)
        },
        on: {
          "click": function($event) {
            return _vm.getDataId($event)
          },
          "change": function($event) {
            var $$a = item.isChecked,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(item, "isChecked", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(item, "isChecked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(item, "isChecked", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.category_name))])])
    }), 0) : _vm._e()])], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          _vm.editCategroyVisible = false
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "loading": _vm.submitLoading
      },
      on: {
        "click": _vm.submitCategoryAction
      }
    }, [_vm._v(_vm._s(_vm.submitLoading ? '提交中' : '保存'))])], 1)
  ], 2)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-685f0f36", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-685f0f36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/marketing/distributor.vue
// module id = 2793
// module chunks = 0